export var DropzoneStatus;

(function (DropzoneStatus) {
  DropzoneStatus["BASE"] = "base";
  DropzoneStatus["ACTIVE"] = "active";
  DropzoneStatus["ACCEPT"] = "accept";
  DropzoneStatus["REJECT"] = "reject";
})(DropzoneStatus || (DropzoneStatus = {}));